module App.Classes {
    export class Question {
        id: number
        name: string
        questionText: string
        type: number
        answers: string[]
    }
}